import type { Components as MarkdownComponents } from "react-markdown";
import { Link as RouterLink } from "react-router";
import { Link } from "@mui/material";
import {
  getInternalAppLink,
  resolveMarkdownLinkText,
} from "./MessageBubble.links.utils";

export const markdownComponents: MarkdownComponents = {
  // ExtraProps includes `node` (hast); strip so it is not spread onto MUI Link / DOM.
  a: ({ node, href, children, ...props }) => {
    const internalAppLink = getInternalAppLink(href);
    if (internalAppLink) {
      return (
        <Link component={RouterLink} to={internalAppLink.to} {...props}>
          {resolveMarkdownLinkText({
            children,
            href,
            displayPath: internalAppLink.displayPath,
          })}
        </Link>
      );
    }
    // Everything else (docs, website, absolute URLs) opens in a new tab.
    return (
      <Link href={href} {...props} target="_blank" rel="noreferrer">
        {children}
      </Link>
    );
  },
};
